import React, {Component} from 'react';
import {Header} from '../Header';
import {Footer} from '../Footer';
import {Helmet} from "react-helmet";

export class AccessibilityIT extends Component {
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>Dichiarazione di accessibilità - CamAPS FX</title>
                    <meta name="title" content="Dichiarazione di accessibilità"/>
                    <meta name="description"
                          content="CamDiab si impegna a favorire e migliorare l’accessibilità e l’usabilità dei propri prodotti digitali per tutte le persone, comprese le persone con disabilità."/>
                    <meta property="og:locale" content="it"/>
                    <meta name="keywords" content="dichiarazione di accessibilità"/>
                </Helmet>
                <Header props={this.props}/>
                <section className="inner-banner">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 col-sm-10">
                                <h1>Dichiarazione di accessibilità</h1>
                                <h3>Versione datata 11 settembre 2026</h3>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="inner-page-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-sm-12">
                                <p>
                                    CamDiab si impegna a favorire e migliorare l’accessibilità e l’usabilità dei propri prodotti digitali per tutte le persone, comprese le persone con disabilità.
                                </p>
                                <h2>
                                    Stato di conformità
                                </h2>
                                <p>
                                    CamDiab mira a raggiungere la conformità alle Linee guida per l’accessibilità dei contenuti Web (WCAG) versione 2.2, livello AA (WCAG 2.2 AA). Queste linee guida riconosciute a livello mondiale contribuiscono a rendere i contenuti Web più accessibili a tutti.
                                </p>
                                <h2>
                                    Ulteriori misure a sostegno dell’accessibilità
                                </h2>
                                <p>
                                    CamDiab sta adottando, tra le altre, le seguenti ulteriori misure per rendere i nostri contenuti digitali più facili da utilizzare:
                                </p>
                                <ul>
                                    <li>Fornire al nostro personale una formazione continua sull’accessibilità</li>
                                    <li>Adottare metodi formali di garanzia della qualità dell’accessibilità tramite valutazioni di terze parti</li>
                                    <li>Assegnare obiettivi e responsabilità chiari in materia di accessibilità</li>
                                </ul>
                                <h2>
                                    Feedback
                                </h2>
                                <p>
                                    Accogliamo con piacere commenti su come migliorare i nostri prodotti digitali per gli utenti con disabilità. Se riscontri difficoltà nella visualizzazione o nella navigazione dei nostri contenuti, oppure noti contenuti, caratteristiche o funzionalità che ritieni non siano pienamente accessibili alle persone con disabilità, contattaci utilizzando il nostro indirizzo e-mail di assistenza: <a href="mailto:support@camdiab.com">support@camdiab.com</a>
                                </p>
                                <p>
                                    Prendiamo seriamente in considerazione il tuo feedback e ne terremo conto nel valutare come soddisfare le esigenze di tutti i nostri clienti e nell’ambito delle nostre politiche generali sull’accessibilità. Inoltre, sebbene non controlliamo i contenuti forniti da fornitori terzi, li incoraggiamo vivamente a fornire contenuti accessibili e facili da usare.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer props={this.props}/>
            </div>
        );
    }
}
